var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metal_list"},_vm._l((_vm.myMedalsList),function(item){return _c('div',{key:item.pk},[_c('img',{staticClass:"metal_item",attrs:{"src":item.medal.image}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }